// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LandingRouteImport } from './routes/$landing'
import { Route as AppRouteImport } from './routes/_app'
import { Route as AboutUsRouteImport } from './routes/about-us'
import { Route as AcademyRouteImport } from './routes/academy'
import { Route as AcademyArticleRouteImport } from './routes/academy-article'
import { Route as AffiliateAgreementRouteImport } from './routes/affiliate-agreement'
import { Route as AuthorRouteImport } from './routes/author'
import { Route as BlogRouteImport } from './routes/blog'
import { Route as BlogCategoriesRouteImport } from './routes/blog-categories'
import { Route as CompliancePolicyRouteImport } from './routes/compliance-policy'
import { Route as FairUsagePolicyRouteImport } from './routes/fair-usage-policy'
import { Route as FeaturesRouteImport } from './routes/features'
import { Route as FrequentlyAskedQuestionsRouteImport } from './routes/frequently-asked-questions'
import { Route as HomeRouteImport } from './routes/home'
import { Route as IntellectualPropertyRouteImport } from './routes/intellectual-property'
import { Route as MasterServicesAgreementRouteImport } from './routes/master-services-agreement'
import { Route as McpServerRouteImport } from './routes/mcp-server'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as PrivacyNoticeForCaliforniaResidentsRouteImport } from './routes/privacy-notice-for-california-residents'
import { Route as PrivacyNoticeForEeaSwitzerlandAndUkRouteImport } from './routes/privacy-notice-for-eea-switzerland-and-uk'
import { Route as PrivacyPolicyRouteImport } from './routes/privacy-policy'
import { Route as ProxyCheckerRouteImport } from './routes/proxy-checker'
import { Route as ProxyLocationsRouteImport } from './routes/proxy-locations'
import { Route as SearchRouteImport } from './routes/search'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as UseCasesRouteImport } from './routes/use-cases'
import { Route as UseCasesCategoriesRouteImport } from './routes/use-cases-categories'
import { Route as LandingIndexRouteImport } from './routes/$landing/index'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppDashboardRouteImport } from './routes/_app/_dashboard'
import { Route as AppAccountdeletedRouteImport } from './routes/_app/accountdeleted'
import { Route as AppAccountsuspensionRouteImport } from './routes/_app/accountsuspension'
import { Route as AppCalculatorRouteImport } from './routes/_app/calculator'
import { Route as AppExpressCheckoutRouteImport } from './routes/_app/express-checkout'
import { Route as AppRegisterRouteImport } from './routes/_app/register'
import { Route as AcademyArticleSlugRouteImport } from './routes/academy-article/$slug'
import { Route as AcademySplatRouteImport } from './routes/academy/$'
import { Route as AuthorSlugRouteImport } from './routes/author/$slug'
import { Route as BlogCategoriesSlugRouteImport } from './routes/blog-categories/$slug'
import { Route as BlogIndexRouteImport } from './routes/blog/index'
import { Route as BlogSlugRouteImport } from './routes/blog/$slug'
import { Route as FeaturesIndexRouteImport } from './routes/features/index'
import { Route as FeaturesSlugRouteImport } from './routes/features/$slug'
import { Route as LSlugRouteImport } from './routes/l/$slug'
import { Route as ProxyLocationsIndexRouteImport } from './routes/proxy-locations/index'
import { Route as ProxyLocationsSlugRouteImport } from './routes/proxy-locations/$slug'
import { Route as UseCasesCategoriesIndexRouteImport } from './routes/use-cases-categories/index'
import { Route as UseCasesCategoriesSlugRouteImport } from './routes/use-cases-categories/$slug'
import { Route as UseCasesIndexRouteImport } from './routes/use-cases/index'
import { Route as UseCasesSlugRouteImport } from './routes/use-cases/$slug'
import { Route as AppDashboardSplatRouteImport } from './routes/_app/_dashboard/$'
import { Route as AppDashboardPlanIdRouteImport } from './routes/_app/_dashboard/$planId'
import { Route as AppDashboard403RouteImport } from './routes/_app/_dashboard/403'
import { Route as AppDashboard404RouteImport } from './routes/_app/_dashboard/404'
import { Route as AppDashboardDashboardRouteImport } from './routes/_app/_dashboard/dashboard'
import { Route as AppDashboardExtensionCaptchaChallengeRouteImport } from './routes/_app/_dashboard/extension-captcha-challenge'
import { Route as AppDashboardProxyTesterRouteImport } from './routes/_app/_dashboard/proxy-tester'
import { Route as AppActivationConfirmRouteImport } from './routes/_app/activation/confirm'
import { Route as AppAuthGoogleRouteImport } from './routes/_app/auth/google'
import { Route as AppLoginIndexRouteImport } from './routes/_app/login/index'
import { Route as AppLoginForgotpasswordRouteImport } from './routes/_app/login/forgotpassword'
import { Route as AppOauthConsentRouteImport } from './routes/_app/oauth/consent'
import { Route as AppProfileProfileRouteImport } from './routes/_app/profile/profile'
import { Route as AppProxyIndexRouteImport } from './routes/_app/proxy/index'
import { Route as AppResetpasswordNewpasswordRouteImport } from './routes/_app/resetpassword/newpassword'
import { Route as AppUserapiIndexRouteImport } from './routes/_app/userapi/index'
import { Route as AppDashboardPlanIdIndexRouteImport } from './routes/_app/_dashboard/$planId/index'
import { Route as AppDashboardPlanIdPricingRouteImport } from './routes/_app/_dashboard/$planId/pricing'
import { Route as AppDashboardPlanIdSettingsRouteImport } from './routes/_app/_dashboard/$planId/settings'
import { Route as AppDashboardAccountverificationIndexRouteImport } from './routes/_app/_dashboard/accountverification/index'
import { Route as AppDashboardAccountverificationAbusereportsRouteImport } from './routes/_app/_dashboard/accountverification/abusereports'
import { Route as AppDashboardEarnReferralRouteImport } from './routes/_app/_dashboard/earn/referral'
import { Route as AppDashboardFederatedaccessFederatedUserIdRouteImport } from './routes/_app/_dashboard/federatedaccess/$federatedUserId'
import { Route as AppDashboardIntegrationsCliSdksRouteImport } from './routes/_app/_dashboard/integrations/cli-sdks'
import { Route as AppDashboardIntegrationsConnectedAppsRouteImport } from './routes/_app/_dashboard/integrations/connected-apps'
import { Route as AppDashboardIntegrationsMcpRouteImport } from './routes/_app/_dashboard/integrations/mcp'
import { Route as AppDashboardIntegrationsSkillsRouteImport } from './routes/_app/_dashboard/integrations/skills'
import { Route as AppDashboardPackagesPackageIdRouteImport } from './routes/_app/_dashboard/packages/$packageId'
import { Route as AppDashboardProfileIndexRouteImport } from './routes/_app/_dashboard/profile/index'
import { Route as AppDashboardProfileVipRouteImport } from './routes/_app/_dashboard/profile/vip'
import { Route as AppDashboardProxyReplaceRouteImport } from './routes/_app/_dashboard/proxy/replace'
import { Route as AppDashboardProxySettingsRouteImport } from './routes/_app/_dashboard/proxy/settings'
import { Route as AppDashboardSubscriptionIndexRouteImport } from './routes/_app/_dashboard/subscription/index'
import { Route as AppDashboardSubscriptionChoosePlanRouteImport } from './routes/_app/_dashboard/subscription/choose-plan'
import { Route as AppDashboardSubscriptionProxyreplacementRouteImport } from './routes/_app/_dashboard/subscription/proxyreplacement'
import { Route as AppDashboardSubuserIndexRouteImport } from './routes/_app/_dashboard/subuser/index'
import { Route as AppDashboardUserapiKeysRouteImport } from './routes/_app/_dashboard/userapi/keys'
import { Route as AppActivationActivationtokenConfirmRouteImport } from './routes/_app/activation/$activationtoken/confirm'
import { Route as AppProfileDeleteaccountDeletedRouteImport } from './routes/_app/profile/deleteaccount/deleted'
import { Route as AppProxyListIndexRouteImport } from './routes/_app/proxy/list/index'
import { Route as AppResetpasswordPasswordresettokenConfirmRouteImport } from './routes/_app/resetpassword/$passwordresettoken/confirm'
import { Route as AppDashboardPlanIdProxyConnectionBuilderRouteImport } from './routes/_app/_dashboard/$planId/proxy/connection-builder'
import { Route as AppDashboardPlanIdProxyEndpointGeneratorRouteImport } from './routes/_app/_dashboard/$planId/proxy/endpoint-generator'
import { Route as AppDashboardPlanIdStatsTabRouteImport } from './routes/_app/_dashboard/$planId/stats/$tab'
import { Route as AppDashboardProfileDeleteaccountIndexRouteImport } from './routes/_app/_dashboard/profile/deleteaccount/index'
import { Route as AppDashboardProxyListReplaceRouteImport } from './routes/_app/_dashboard/proxy/list/replace'
import { Route as AppDashboardProxyListReplacedRouteImport } from './routes/_app/_dashboard/proxy/list/replaced'
import { Route as AppDashboardSubscriptionCancelIndexRouteImport } from './routes/_app/_dashboard/subscription/cancel/index'
import { Route as AppDashboardSubscriptionCancelChooseRouteImport } from './routes/_app/_dashboard/subscription/cancel/choose'
import { Route as AppDashboardSubscriptionCancelConfirmRouteImport } from './routes/_app/_dashboard/subscription/cancel/confirm'
import { Route as AppDashboardSubscriptionCancelContactRouteImport } from './routes/_app/_dashboard/subscription/cancel/contact'
import { Route as AppDashboardSubscriptionCustomizeIndexRouteImport } from './routes/_app/_dashboard/subscription/customize/index'
import { Route as AppDashboardSubscriptionCustomizeCheckoutRouteImport } from './routes/_app/_dashboard/subscription/customize/checkout'
import { Route as AppDashboardSubscriptionCustomizeDoneRouteImport } from './routes/_app/_dashboard/subscription/customize/done'
import { Route as AppDashboardSubscriptionInvoicesIndexRouteImport } from './routes/_app/_dashboard/subscription/invoices/index'
import { Route as AppDashboardSubscriptionInvoicesInvoiceIdRouteImport } from './routes/_app/_dashboard/subscription/invoices/$invoiceId'
import { Route as AppDashboardSubscriptionPendingPaymentidRouteImport } from './routes/_app/_dashboard/subscription/pending/$paymentid'
import { Route as AppDashboardPlanIdProxyListIndexRouteImport } from './routes/_app/_dashboard/$planId/proxy/list/index'
import { Route as AppDashboardPlanIdProxyListReplaceRouteImport } from './routes/_app/_dashboard/$planId/proxy/list/replace'
import { Route as AppDashboardPlanIdProxyListReplacedRouteImport } from './routes/_app/_dashboard/$planId/proxy/list/replaced'
import { Route as AppDashboardProfileChangeemailConfirmationConfirmRouteImport } from './routes/_app/_dashboard/profile/changeemail/$confirmation/confirm'
import { Route as AppDashboardSubuserUserUseridDetailRouteImport } from './routes/_app/_dashboard/subuser/user/$userid/detail'

const LandingRoute = LandingRouteImport.update({
            id: '/$landing',path: '/$landing',getParentRoute: () => rootRouteImport
          })
const AppRoute = AppRouteImport.update({
            id: '/_app',getParentRoute: () => rootRouteImport
          })
const AboutUsRoute = AboutUsRouteImport.update({
            id: '/about-us',path: '/about-us',getParentRoute: () => rootRouteImport
          })
const AcademyRoute = AcademyRouteImport.update({
            id: '/academy',path: '/academy',getParentRoute: () => rootRouteImport
          })
const AcademyArticleRoute = AcademyArticleRouteImport.update({
            id: '/academy-article',path: '/academy-article',getParentRoute: () => rootRouteImport
          })
const AffiliateAgreementRoute = AffiliateAgreementRouteImport.update({
            id: '/affiliate-agreement',path: '/affiliate-agreement',getParentRoute: () => rootRouteImport
          })
const AuthorRoute = AuthorRouteImport.update({
            id: '/author',path: '/author',getParentRoute: () => rootRouteImport
          })
const BlogRoute = BlogRouteImport.update({
            id: '/blog',path: '/blog',getParentRoute: () => rootRouteImport
          })
const BlogCategoriesRoute = BlogCategoriesRouteImport.update({
            id: '/blog-categories',path: '/blog-categories',getParentRoute: () => rootRouteImport
          })
const CompliancePolicyRoute = CompliancePolicyRouteImport.update({
            id: '/compliance-policy',path: '/compliance-policy',getParentRoute: () => rootRouteImport
          })
const FairUsagePolicyRoute = FairUsagePolicyRouteImport.update({
            id: '/fair-usage-policy',path: '/fair-usage-policy',getParentRoute: () => rootRouteImport
          })
const FeaturesRoute = FeaturesRouteImport.update({
            id: '/features',path: '/features',getParentRoute: () => rootRouteImport
          })
const FrequentlyAskedQuestionsRoute = FrequentlyAskedQuestionsRouteImport.update({
            id: '/frequently-asked-questions',path: '/frequently-asked-questions',getParentRoute: () => rootRouteImport
          })
const HomeRoute = HomeRouteImport.update({
            id: '/home',path: '/home',getParentRoute: () => rootRouteImport
          })
const IntellectualPropertyRoute = IntellectualPropertyRouteImport.update({
            id: '/intellectual-property',path: '/intellectual-property',getParentRoute: () => rootRouteImport
          })
const MasterServicesAgreementRoute = MasterServicesAgreementRouteImport.update({
            id: '/master-services-agreement',path: '/master-services-agreement',getParentRoute: () => rootRouteImport
          })
const McpServerRoute = McpServerRouteImport.update({
            id: '/mcp-server',path: '/mcp-server',getParentRoute: () => rootRouteImport
          })
const PricingRoute = PricingRouteImport.update({
            id: '/pricing',path: '/pricing',getParentRoute: () => rootRouteImport
          })
const PrivacyNoticeForCaliforniaResidentsRoute = PrivacyNoticeForCaliforniaResidentsRouteImport.update({
            id: '/privacy-notice-for-california-residents',path: '/privacy-notice-for-california-residents',getParentRoute: () => rootRouteImport
          })
const PrivacyNoticeForEeaSwitzerlandAndUkRoute = PrivacyNoticeForEeaSwitzerlandAndUkRouteImport.update({
            id: '/privacy-notice-for-eea-switzerland-and-uk',path: '/privacy-notice-for-eea-switzerland-and-uk',getParentRoute: () => rootRouteImport
          })
const PrivacyPolicyRoute = PrivacyPolicyRouteImport.update({
            id: '/privacy-policy',path: '/privacy-policy',getParentRoute: () => rootRouteImport
          })
const ProxyCheckerRoute = ProxyCheckerRouteImport.update({
            id: '/proxy-checker',path: '/proxy-checker',getParentRoute: () => rootRouteImport
          })
const ProxyLocationsRoute = ProxyLocationsRouteImport.update({
            id: '/proxy-locations',path: '/proxy-locations',getParentRoute: () => rootRouteImport
          })
const SearchRoute = SearchRouteImport.update({
            id: '/search',path: '/search',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const UseCasesRoute = UseCasesRouteImport.update({
            id: '/use-cases',path: '/use-cases',getParentRoute: () => rootRouteImport
          })
const UseCasesCategoriesRoute = UseCasesCategoriesRouteImport.update({
            id: '/use-cases-categories',path: '/use-cases-categories',getParentRoute: () => rootRouteImport
          })
const LandingIndexRoute = LandingIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => LandingRoute
          })
const AppIndexRoute = AppIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppRoute
          })
const AppDashboardRoute = AppDashboardRouteImport.update({
            id: '/_dashboard',getParentRoute: () => AppRoute
          })
const AppAccountdeletedRoute = AppAccountdeletedRouteImport.update({
            id: '/accountdeleted',path: '/accountdeleted',getParentRoute: () => AppRoute
          })
const AppAccountsuspensionRoute = AppAccountsuspensionRouteImport.update({
            id: '/accountsuspension',path: '/accountsuspension',getParentRoute: () => AppRoute
          })
const AppCalculatorRoute = AppCalculatorRouteImport.update({
            id: '/calculator',path: '/calculator',getParentRoute: () => AppRoute
          })
const AppExpressCheckoutRoute = AppExpressCheckoutRouteImport.update({
            id: '/express-checkout',path: '/express-checkout',getParentRoute: () => AppRoute
          })
const AppRegisterRoute = AppRegisterRouteImport.update({
            id: '/register',path: '/register',getParentRoute: () => AppRoute
          })
const AcademyArticleSlugRoute = AcademyArticleSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => AcademyArticleRoute
          })
const AcademySplatRoute = AcademySplatRouteImport.update({
            id: '/$',path: '/$',getParentRoute: () => AcademyRoute
          })
const AuthorSlugRoute = AuthorSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => AuthorRoute
          })
const BlogCategoriesSlugRoute = BlogCategoriesSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => BlogCategoriesRoute
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => BlogRoute
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => BlogRoute
          })
const FeaturesIndexRoute = FeaturesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => FeaturesRoute
          })
const FeaturesSlugRoute = FeaturesSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => FeaturesRoute
          })
const LSlugRoute = LSlugRouteImport.update({
            id: '/l/$slug',path: '/l/$slug',getParentRoute: () => rootRouteImport
          })
const ProxyLocationsIndexRoute = ProxyLocationsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ProxyLocationsRoute
          })
const ProxyLocationsSlugRoute = ProxyLocationsSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => ProxyLocationsRoute
          })
const UseCasesCategoriesIndexRoute = UseCasesCategoriesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => UseCasesCategoriesRoute
          })
const UseCasesCategoriesSlugRoute = UseCasesCategoriesSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => UseCasesCategoriesRoute
          })
const UseCasesIndexRoute = UseCasesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => UseCasesRoute
          })
const UseCasesSlugRoute = UseCasesSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => UseCasesRoute
          })
const AppDashboardSplatRoute = AppDashboardSplatRouteImport.update({
            id: '/$',path: '/$',getParentRoute: () => AppDashboardRoute
          })
const AppDashboardPlanIdRoute = AppDashboardPlanIdRouteImport.update({
            id: '/$planId',path: '/$planId',getParentRoute: () => AppDashboardRoute
          })
const AppDashboard403Route = AppDashboard403RouteImport.update({
            id: '/403',path: '/403',getParentRoute: () => AppDashboardRoute
          })
const AppDashboard404Route = AppDashboard404RouteImport.update({
            id: '/404',path: '/404',getParentRoute: () => AppDashboardRoute
          })
const AppDashboardDashboardRoute = AppDashboardDashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => AppDashboardRoute
          })
const AppDashboardExtensionCaptchaChallengeRoute = AppDashboardExtensionCaptchaChallengeRouteImport.update({
            id: '/extension-captcha-challenge',path: '/extension-captcha-challenge',getParentRoute: () => AppDashboardRoute
          })
const AppDashboardProxyTesterRoute = AppDashboardProxyTesterRouteImport.update({
            id: '/proxy-tester',path: '/proxy-tester',getParentRoute: () => AppDashboardRoute
          })
const AppActivationConfirmRoute = AppActivationConfirmRouteImport.update({
            id: '/activation/confirm',path: '/activation/confirm',getParentRoute: () => AppRoute
          })
const AppAuthGoogleRoute = AppAuthGoogleRouteImport.update({
            id: '/auth/google',path: '/auth/google',getParentRoute: () => AppRoute
          })
const AppLoginIndexRoute = AppLoginIndexRouteImport.update({
            id: '/login/',path: '/login/',getParentRoute: () => AppRoute
          })
const AppLoginForgotpasswordRoute = AppLoginForgotpasswordRouteImport.update({
            id: '/login/forgotpassword',path: '/login/forgotpassword',getParentRoute: () => AppRoute
          })
const AppOauthConsentRoute = AppOauthConsentRouteImport.update({
            id: '/oauth/consent',path: '/oauth/consent',getParentRoute: () => AppRoute
          })
const AppProfileProfileRoute = AppProfileProfileRouteImport.update({
            id: '/profile/profile',path: '/profile/profile',getParentRoute: () => AppRoute
          })
const AppProxyIndexRoute = AppProxyIndexRouteImport.update({
            id: '/proxy/',path: '/proxy/',getParentRoute: () => AppRoute
          })
const AppResetpasswordNewpasswordRoute = AppResetpasswordNewpasswordRouteImport.update({
            id: '/resetpassword/newpassword',path: '/resetpassword/newpassword',getParentRoute: () => AppRoute
          })
const AppUserapiIndexRoute = AppUserapiIndexRouteImport.update({
            id: '/userapi/',path: '/userapi/',getParentRoute: () => AppRoute
          })
const AppDashboardPlanIdIndexRoute = AppDashboardPlanIdIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppDashboardPlanIdRoute
          })
const AppDashboardPlanIdPricingRoute = AppDashboardPlanIdPricingRouteImport.update({
            id: '/pricing',path: '/pricing',getParentRoute: () => AppDashboardPlanIdRoute
          })
const AppDashboardPlanIdSettingsRoute = AppDashboardPlanIdSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => AppDashboardPlanIdRoute
          })
const AppDashboardAccountverificationIndexRoute = AppDashboardAccountverificationIndexRouteImport.update({
            id: '/accountverification/',path: '/accountverification/',getParentRoute: () => AppDashboardRoute
          })
const AppDashboardAccountverificationAbusereportsRoute = AppDashboardAccountverificationAbusereportsRouteImport.update({
            id: '/accountverification/abusereports',path: '/accountverification/abusereports',getParentRoute: () => AppDashboardRoute
          })
const AppDashboardEarnReferralRoute = AppDashboardEarnReferralRouteImport.update({
            id: '/earn/referral',path: '/earn/referral',getParentRoute: () => AppDashboardRoute
          })
const AppDashboardFederatedaccessFederatedUserIdRoute = AppDashboardFederatedaccessFederatedUserIdRouteImport.update({
            id: '/federatedaccess/$federatedUserId',path: '/federatedaccess/$federatedUserId',getParentRoute: () => AppDashboardRoute
          })
const AppDashboardIntegrationsCliSdksRoute = AppDashboardIntegrationsCliSdksRouteImport.update({
            id: '/integrations/cli-sdks',path: '/integrations/cli-sdks',getParentRoute: () => AppDashboardRoute
          })
const AppDashboardIntegrationsConnectedAppsRoute = AppDashboardIntegrationsConnectedAppsRouteImport.update({
            id: '/integrations/connected-apps',path: '/integrations/connected-apps',getParentRoute: () => AppDashboardRoute
          })
const AppDashboardIntegrationsMcpRoute = AppDashboardIntegrationsMcpRouteImport.update({
            id: '/integrations/mcp',path: '/integrations/mcp',getParentRoute: () => AppDashboardRoute
          })
const AppDashboardIntegrationsSkillsRoute = AppDashboardIntegrationsSkillsRouteImport.update({
            id: '/integrations/skills',path: '/integrations/skills',getParentRoute: () => AppDashboardRoute
          })
const AppDashboardPackagesPackageIdRoute = AppDashboardPackagesPackageIdRouteImport.update({
            id: '/packages/$packageId',path: '/packages/$packageId',getParentRoute: () => AppDashboardRoute
          })
const AppDashboardProfileIndexRoute = AppDashboardProfileIndexRouteImport.update({
            id: '/profile/',path: '/profile/',getParentRoute: () => AppDashboardRoute
          })
const AppDashboardProfileVipRoute = AppDashboardProfileVipRouteImport.update({
            id: '/profile/vip',path: '/profile/vip',getParentRoute: () => AppDashboardRoute
          })
const AppDashboardProxyReplaceRoute = AppDashboardProxyReplaceRouteImport.update({
            id: '/proxy/replace',path: '/proxy/replace',getParentRoute: () => AppDashboardRoute
          })
const AppDashboardProxySettingsRoute = AppDashboardProxySettingsRouteImport.update({
            id: '/proxy/settings',path: '/proxy/settings',getParentRoute: () => AppDashboardRoute
          })
const AppDashboardSubscriptionIndexRoute = AppDashboardSubscriptionIndexRouteImport.update({
            id: '/subscription/',path: '/subscription/',getParentRoute: () => AppDashboardRoute
          })
const AppDashboardSubscriptionChoosePlanRoute = AppDashboardSubscriptionChoosePlanRouteImport.update({
            id: '/subscription/choose-plan',path: '/subscription/choose-plan',getParentRoute: () => AppDashboardRoute
          })
const AppDashboardSubscriptionProxyreplacementRoute = AppDashboardSubscriptionProxyreplacementRouteImport.update({
            id: '/subscription/proxyreplacement',path: '/subscription/proxyreplacement',getParentRoute: () => AppDashboardRoute
          })
const AppDashboardSubuserIndexRoute = AppDashboardSubuserIndexRouteImport.update({
            id: '/subuser/',path: '/subuser/',getParentRoute: () => AppDashboardRoute
          })
const AppDashboardUserapiKeysRoute = AppDashboardUserapiKeysRouteImport.update({
            id: '/userapi/keys',path: '/userapi/keys',getParentRoute: () => AppDashboardRoute
          })
const AppActivationActivationtokenConfirmRoute = AppActivationActivationtokenConfirmRouteImport.update({
            id: '/activation/$activationtoken/confirm',path: '/activation/$activationtoken/confirm',getParentRoute: () => AppRoute
          })
const AppProfileDeleteaccountDeletedRoute = AppProfileDeleteaccountDeletedRouteImport.update({
            id: '/profile/deleteaccount/deleted',path: '/profile/deleteaccount/deleted',getParentRoute: () => AppRoute
          })
const AppProxyListIndexRoute = AppProxyListIndexRouteImport.update({
            id: '/proxy/list/',path: '/proxy/list/',getParentRoute: () => AppRoute
          })
const AppResetpasswordPasswordresettokenConfirmRoute = AppResetpasswordPasswordresettokenConfirmRouteImport.update({
            id: '/resetpassword/$passwordresettoken/confirm',path: '/resetpassword/$passwordresettoken/confirm',getParentRoute: () => AppRoute
          })
const AppDashboardPlanIdProxyConnectionBuilderRoute = AppDashboardPlanIdProxyConnectionBuilderRouteImport.update({
            id: '/proxy/connection-builder',path: '/proxy/connection-builder',getParentRoute: () => AppDashboardPlanIdRoute
          })
const AppDashboardPlanIdProxyEndpointGeneratorRoute = AppDashboardPlanIdProxyEndpointGeneratorRouteImport.update({
            id: '/proxy/endpoint-generator',path: '/proxy/endpoint-generator',getParentRoute: () => AppDashboardPlanIdRoute
          })
const AppDashboardPlanIdStatsTabRoute = AppDashboardPlanIdStatsTabRouteImport.update({
            id: '/stats/$tab',path: '/stats/$tab',getParentRoute: () => AppDashboardPlanIdRoute
          })
const AppDashboardProfileDeleteaccountIndexRoute = AppDashboardProfileDeleteaccountIndexRouteImport.update({
            id: '/profile/deleteaccount/',path: '/profile/deleteaccount/',getParentRoute: () => AppDashboardRoute
          })
const AppDashboardProxyListReplaceRoute = AppDashboardProxyListReplaceRouteImport.update({
            id: '/proxy/list/replace',path: '/proxy/list/replace',getParentRoute: () => AppDashboardRoute
          })
const AppDashboardProxyListReplacedRoute = AppDashboardProxyListReplacedRouteImport.update({
            id: '/proxy/list/replaced',path: '/proxy/list/replaced',getParentRoute: () => AppDashboardRoute
          })
const AppDashboardSubscriptionCancelIndexRoute = AppDashboardSubscriptionCancelIndexRouteImport.update({
            id: '/subscription/cancel/',path: '/subscription/cancel/',getParentRoute: () => AppDashboardRoute
          })
const AppDashboardSubscriptionCancelChooseRoute = AppDashboardSubscriptionCancelChooseRouteImport.update({
            id: '/subscription/cancel/choose',path: '/subscription/cancel/choose',getParentRoute: () => AppDashboardRoute
          })
const AppDashboardSubscriptionCancelConfirmRoute = AppDashboardSubscriptionCancelConfirmRouteImport.update({
            id: '/subscription/cancel/confirm',path: '/subscription/cancel/confirm',getParentRoute: () => AppDashboardRoute
          })
const AppDashboardSubscriptionCancelContactRoute = AppDashboardSubscriptionCancelContactRouteImport.update({
            id: '/subscription/cancel/contact',path: '/subscription/cancel/contact',getParentRoute: () => AppDashboardRoute
          })
const AppDashboardSubscriptionCustomizeIndexRoute = AppDashboardSubscriptionCustomizeIndexRouteImport.update({
            id: '/subscription/customize/',path: '/subscription/customize/',getParentRoute: () => AppDashboardRoute
          })
const AppDashboardSubscriptionCustomizeCheckoutRoute = AppDashboardSubscriptionCustomizeCheckoutRouteImport.update({
            id: '/subscription/customize/checkout',path: '/subscription/customize/checkout',getParentRoute: () => AppDashboardRoute
          })
const AppDashboardSubscriptionCustomizeDoneRoute = AppDashboardSubscriptionCustomizeDoneRouteImport.update({
            id: '/subscription/customize/done',path: '/subscription/customize/done',getParentRoute: () => AppDashboardRoute
          })
const AppDashboardSubscriptionInvoicesIndexRoute = AppDashboardSubscriptionInvoicesIndexRouteImport.update({
            id: '/subscription/invoices/',path: '/subscription/invoices/',getParentRoute: () => AppDashboardRoute
          })
const AppDashboardSubscriptionInvoicesInvoiceIdRoute = AppDashboardSubscriptionInvoicesInvoiceIdRouteImport.update({
            id: '/subscription/invoices/$invoiceId',path: '/subscription/invoices/$invoiceId',getParentRoute: () => AppDashboardRoute
          })
const AppDashboardSubscriptionPendingPaymentidRoute = AppDashboardSubscriptionPendingPaymentidRouteImport.update({
            id: '/subscription/pending/$paymentid',path: '/subscription/pending/$paymentid',getParentRoute: () => AppDashboardRoute
          })
const AppDashboardPlanIdProxyListIndexRoute = AppDashboardPlanIdProxyListIndexRouteImport.update({
            id: '/proxy/list/',path: '/proxy/list/',getParentRoute: () => AppDashboardPlanIdRoute
          })
const AppDashboardPlanIdProxyListReplaceRoute = AppDashboardPlanIdProxyListReplaceRouteImport.update({
            id: '/proxy/list/replace',path: '/proxy/list/replace',getParentRoute: () => AppDashboardPlanIdRoute
          })
const AppDashboardPlanIdProxyListReplacedRoute = AppDashboardPlanIdProxyListReplacedRouteImport.update({
            id: '/proxy/list/replaced',path: '/proxy/list/replaced',getParentRoute: () => AppDashboardPlanIdRoute
          })
const AppDashboardProfileChangeemailConfirmationConfirmRoute = AppDashboardProfileChangeemailConfirmationConfirmRouteImport.update({
            id: '/profile/changeemail/$confirmation/confirm',path: '/profile/changeemail/$confirmation/confirm',getParentRoute: () => AppDashboardRoute
          })
const AppDashboardSubuserUserUseridDetailRoute = AppDashboardSubuserUserUseridDetailRouteImport.update({
            id: '/subuser/user/$userid/detail',path: '/subuser/user/$userid/detail',getParentRoute: () => AppDashboardRoute
          })





const LandingRouteChildren = {
  LandingIndexRoute: LandingIndexRoute
}

const LandingRouteWithChildren = LandingRoute._addFileChildren(LandingRouteChildren)




const AppDashboardPlanIdRouteChildren = {
  AppDashboardPlanIdPricingRoute: AppDashboardPlanIdPricingRoute,AppDashboardPlanIdSettingsRoute: AppDashboardPlanIdSettingsRoute,AppDashboardPlanIdIndexRoute: AppDashboardPlanIdIndexRoute,AppDashboardPlanIdProxyConnectionBuilderRoute: AppDashboardPlanIdProxyConnectionBuilderRoute,AppDashboardPlanIdProxyEndpointGeneratorRoute: AppDashboardPlanIdProxyEndpointGeneratorRoute,AppDashboardPlanIdStatsTabRoute: AppDashboardPlanIdStatsTabRoute,AppDashboardPlanIdProxyListReplaceRoute: AppDashboardPlanIdProxyListReplaceRoute,AppDashboardPlanIdProxyListReplacedRoute: AppDashboardPlanIdProxyListReplacedRoute,AppDashboardPlanIdProxyListIndexRoute: AppDashboardPlanIdProxyListIndexRoute
}

const AppDashboardPlanIdRouteWithChildren = AppDashboardPlanIdRoute._addFileChildren(AppDashboardPlanIdRouteChildren)



const AppDashboardRouteChildren = {
  AppDashboardSplatRoute: AppDashboardSplatRoute,AppDashboardPlanIdRoute: AppDashboardPlanIdRouteWithChildren,AppDashboard403Route: AppDashboard403Route,AppDashboard404Route: AppDashboard404Route,AppDashboardDashboardRoute: AppDashboardDashboardRoute,AppDashboardExtensionCaptchaChallengeRoute: AppDashboardExtensionCaptchaChallengeRoute,AppDashboardProxyTesterRoute: AppDashboardProxyTesterRoute,AppDashboardAccountverificationAbusereportsRoute: AppDashboardAccountverificationAbusereportsRoute,AppDashboardEarnReferralRoute: AppDashboardEarnReferralRoute,AppDashboardFederatedaccessFederatedUserIdRoute: AppDashboardFederatedaccessFederatedUserIdRoute,AppDashboardIntegrationsCliSdksRoute: AppDashboardIntegrationsCliSdksRoute,AppDashboardIntegrationsConnectedAppsRoute: AppDashboardIntegrationsConnectedAppsRoute,AppDashboardIntegrationsMcpRoute: AppDashboardIntegrationsMcpRoute,AppDashboardIntegrationsSkillsRoute: AppDashboardIntegrationsSkillsRoute,AppDashboardPackagesPackageIdRoute: AppDashboardPackagesPackageIdRoute,AppDashboardProfileVipRoute: AppDashboardProfileVipRoute,AppDashboardProxyReplaceRoute: AppDashboardProxyReplaceRoute,AppDashboardProxySettingsRoute: AppDashboardProxySettingsRoute,AppDashboardSubscriptionChoosePlanRoute: AppDashboardSubscriptionChoosePlanRoute,AppDashboardSubscriptionProxyreplacementRoute: AppDashboardSubscriptionProxyreplacementRoute,AppDashboardUserapiKeysRoute: AppDashboardUserapiKeysRoute,AppDashboardAccountverificationIndexRoute: AppDashboardAccountverificationIndexRoute,AppDashboardProfileIndexRoute: AppDashboardProfileIndexRoute,AppDashboardSubscriptionIndexRoute: AppDashboardSubscriptionIndexRoute,AppDashboardSubuserIndexRoute: AppDashboardSubuserIndexRoute,AppDashboardProxyListReplaceRoute: AppDashboardProxyListReplaceRoute,AppDashboardProxyListReplacedRoute: AppDashboardProxyListReplacedRoute,AppDashboardSubscriptionCancelChooseRoute: AppDashboardSubscriptionCancelChooseRoute,AppDashboardSubscriptionCancelConfirmRoute: AppDashboardSubscriptionCancelConfirmRoute,AppDashboardSubscriptionCancelContactRoute: AppDashboardSubscriptionCancelContactRoute,AppDashboardSubscriptionCustomizeCheckoutRoute: AppDashboardSubscriptionCustomizeCheckoutRoute,AppDashboardSubscriptionCustomizeDoneRoute: AppDashboardSubscriptionCustomizeDoneRoute,AppDashboardSubscriptionInvoicesInvoiceIdRoute: AppDashboardSubscriptionInvoicesInvoiceIdRoute,AppDashboardSubscriptionPendingPaymentidRoute: AppDashboardSubscriptionPendingPaymentidRoute,AppDashboardProfileDeleteaccountIndexRoute: AppDashboardProfileDeleteaccountIndexRoute,AppDashboardSubscriptionCancelIndexRoute: AppDashboardSubscriptionCancelIndexRoute,AppDashboardSubscriptionCustomizeIndexRoute: AppDashboardSubscriptionCustomizeIndexRoute,AppDashboardSubscriptionInvoicesIndexRoute: AppDashboardSubscriptionInvoicesIndexRoute,AppDashboardProfileChangeemailConfirmationConfirmRoute: AppDashboardProfileChangeemailConfirmationConfirmRoute,AppDashboardSubuserUserUseridDetailRoute: AppDashboardSubuserUserUseridDetailRoute
}

const AppDashboardRouteWithChildren = AppDashboardRoute._addFileChildren(AppDashboardRouteChildren)



const AppRouteChildren = {
  AppDashboardRoute: AppDashboardRouteWithChildren,AppAccountdeletedRoute: AppAccountdeletedRoute,AppAccountsuspensionRoute: AppAccountsuspensionRoute,AppCalculatorRoute: AppCalculatorRoute,AppExpressCheckoutRoute: AppExpressCheckoutRoute,AppRegisterRoute: AppRegisterRoute,AppIndexRoute: AppIndexRoute,AppActivationConfirmRoute: AppActivationConfirmRoute,AppAuthGoogleRoute: AppAuthGoogleRoute,AppLoginForgotpasswordRoute: AppLoginForgotpasswordRoute,AppOauthConsentRoute: AppOauthConsentRoute,AppProfileProfileRoute: AppProfileProfileRoute,AppResetpasswordNewpasswordRoute: AppResetpasswordNewpasswordRoute,AppLoginIndexRoute: AppLoginIndexRoute,AppProxyIndexRoute: AppProxyIndexRoute,AppUserapiIndexRoute: AppUserapiIndexRoute,AppActivationActivationtokenConfirmRoute: AppActivationActivationtokenConfirmRoute,AppProfileDeleteaccountDeletedRoute: AppProfileDeleteaccountDeletedRoute,AppResetpasswordPasswordresettokenConfirmRoute: AppResetpasswordPasswordresettokenConfirmRoute,AppProxyListIndexRoute: AppProxyListIndexRoute
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)




const AcademyRouteChildren = {
  AcademySplatRoute: AcademySplatRoute
}

const AcademyRouteWithChildren = AcademyRoute._addFileChildren(AcademyRouteChildren)




const AcademyArticleRouteChildren = {
  AcademyArticleSlugRoute: AcademyArticleSlugRoute
}

const AcademyArticleRouteWithChildren = AcademyArticleRoute._addFileChildren(AcademyArticleRouteChildren)




const AuthorRouteChildren = {
  AuthorSlugRoute: AuthorSlugRoute
}

const AuthorRouteWithChildren = AuthorRoute._addFileChildren(AuthorRouteChildren)




const BlogRouteChildren = {
  BlogSlugRoute: BlogSlugRoute,BlogIndexRoute: BlogIndexRoute
}

const BlogRouteWithChildren = BlogRoute._addFileChildren(BlogRouteChildren)




const BlogCategoriesRouteChildren = {
  BlogCategoriesSlugRoute: BlogCategoriesSlugRoute
}

const BlogCategoriesRouteWithChildren = BlogCategoriesRoute._addFileChildren(BlogCategoriesRouteChildren)




const FeaturesRouteChildren = {
  FeaturesSlugRoute: FeaturesSlugRoute,FeaturesIndexRoute: FeaturesIndexRoute
}

const FeaturesRouteWithChildren = FeaturesRoute._addFileChildren(FeaturesRouteChildren)




const ProxyLocationsRouteChildren = {
  ProxyLocationsSlugRoute: ProxyLocationsSlugRoute,ProxyLocationsIndexRoute: ProxyLocationsIndexRoute
}

const ProxyLocationsRouteWithChildren = ProxyLocationsRoute._addFileChildren(ProxyLocationsRouteChildren)




const UseCasesRouteChildren = {
  UseCasesSlugRoute: UseCasesSlugRoute,UseCasesIndexRoute: UseCasesIndexRoute
}

const UseCasesRouteWithChildren = UseCasesRoute._addFileChildren(UseCasesRouteChildren)




const UseCasesCategoriesRouteChildren = {
  UseCasesCategoriesSlugRoute: UseCasesCategoriesSlugRoute,UseCasesCategoriesIndexRoute: UseCasesCategoriesIndexRoute
}

const UseCasesCategoriesRouteWithChildren = UseCasesCategoriesRoute._addFileChildren(UseCasesCategoriesRouteChildren)

const rootRouteChildren = {
  LandingRoute: LandingRouteWithChildren,AppRoute: AppRouteWithChildren,AboutUsRoute: AboutUsRoute,AcademyRoute: AcademyRouteWithChildren,AcademyArticleRoute: AcademyArticleRouteWithChildren,AffiliateAgreementRoute: AffiliateAgreementRoute,AuthorRoute: AuthorRouteWithChildren,BlogRoute: BlogRouteWithChildren,BlogCategoriesRoute: BlogCategoriesRouteWithChildren,CompliancePolicyRoute: CompliancePolicyRoute,FairUsagePolicyRoute: FairUsagePolicyRoute,FeaturesRoute: FeaturesRouteWithChildren,FrequentlyAskedQuestionsRoute: FrequentlyAskedQuestionsRoute,HomeRoute: HomeRoute,IntellectualPropertyRoute: IntellectualPropertyRoute,MasterServicesAgreementRoute: MasterServicesAgreementRoute,McpServerRoute: McpServerRoute,PricingRoute: PricingRoute,PrivacyNoticeForCaliforniaResidentsRoute: PrivacyNoticeForCaliforniaResidentsRoute,PrivacyNoticeForEeaSwitzerlandAndUkRoute: PrivacyNoticeForEeaSwitzerlandAndUkRoute,PrivacyPolicyRoute: PrivacyPolicyRoute,ProxyCheckerRoute: ProxyCheckerRoute,ProxyLocationsRoute: ProxyLocationsRouteWithChildren,SearchRoute: SearchRoute,TermsRoute: TermsRoute,UseCasesRoute: UseCasesRouteWithChildren,UseCasesCategoriesRoute: UseCasesCategoriesRouteWithChildren,LSlugRoute: LSlugRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)